<template>
  <div>
    <div class="title">收款信息</div>
    <vxe-table
      :data="detail"
      auto-resize
      border
      align="center"
      header-align="center"
      style="margin-top: 5px; margin-bottom: 20px; width: 100%"
    >
      <vxe-table-column field="seq" title="收款单号"> </vxe-table-column>
      <vxe-table-column field="spaceAssetName" title="收款日期"></vxe-table-column>
      <vxe-table-column field="spaceUnitName" title="收款金额"></vxe-table-column>
      <vxe-table-column field="spaceFloorName" title="收款银行名称"></vxe-table-column>
      <vxe-table-column field="spaceRoomName" title="收款银行账号"></vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  export default {
    name: 'CollectionInfo',
    props: {
      detail: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
  };
</script>
<style scoped lang="scss">
  .title {
    font-size: 20px;
    color: black;
    margin-left: 10px;
    margin-top: 20px;
    font-weight: bolder;
  }
  // .vxe-table {
  //   width: 100%;

  //   display: flex;

  //   flex-direction: column;

  //   .vxe-table__body-wrapper {
  //     flex: 1;
  //   }
  // }
</style>
